import { TFunction } from 'i18next';
import { z } from 'zod';

export const getPositionSchema = (t: TFunction) =>
  z.object({
    position: z.string().nonempty(t('common.validation.fieldRequired')),
    description: z.string().nonempty(t('common.validation.fieldRequired')),
    positionId: z.string().optional(),
  });
